<div class="card p-3 pb-5 mb-5 flex flex-col gap-3 mt-2">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="flex flex-col">
    <div class="flex items-center gap-3">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt="back"
        class="cursor-pointer"
        (click)="back()"
      />
      <div class="title">Business Information</div>
    </div>
    <hr />

    <form [formGroup]="businessForm">
      <div class="flex flex-col p-4">
        <div class="flex flex-col gap-3">
          <div class="flex gap-2">
            <label>Business Entity<span class="text-danger">*</span></label>
            <span nz-icon nzType="question-circle" nzTheme="outline"></span> :
          </div>
          <div class="flex gap-2">
            <nz-radio-group
              formControlName="business_entity"
              class="flex flex-col gap-3"
            >
              <div nz-row [nzGutter]="16">
                <div nz-col class="flex flex-col gap-2">
                  <label nz-radio [nzValue]="1">Limited Company / PT</label>
                  <label nz-radio [nzValue]="2">Limited Partnership / CV</label>
                </div>
                <div nz-col class="flex flex-col gap-2">
                  <label nz-radio [nzValue]="3"
                    >State Institution / Instansi Negara</label
                  >
                  <label nz-radio [nzValue]="4">Cooperative / Koperasi</label>
                </div>
                <div nz-col class="flex flex-col gap-2">
                  <label nz-radio [nzValue]="5">Others</label>
                  <div *ngIf="businessForm.get('business_entity')?.value === 5">
                    <input
                      nz-input
                      formControlName="business_entity_others_name"
                      placeholder="e.g Yayasan"
                      maxlength="20"
                      (input)="validateEntityOthers();checkEntityOthersState()"
                      [nzStatus]="validEntityOthers ? '' : 'error'"
                    />
                    <span class="flex items-center gap-1 text-danger text-[14px]">
                      <img
                        *ngIf="errMessEntityOthers !== ''"
                        src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                        alt="warning"
                        style="max-width: 10px; max-height: 10px"
                      />
                      {{ errMessEntityOthers }}</span
                    >
                  </div>
                </div>
              </div>
            </nz-radio-group>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row gap-3 mt-5">
          <div class="flex flex-col gap-2 col">
            <div class="flex gap-2">
              <label>Business Name<span class="text-danger">*</span></label>
              <span nz-icon nzType="question-circle" nzTheme="outline"></span> :
            </div>
            <input
              nz-input
              formControlName="business_name"
              placeholder="e.g PT. John Doe"
              type="text"
              (keypress)="setRegexBName($event)"
              (input)="validateBusinessName()"
              [nzStatus]="validBName ? '' : 'error'"
            />
            <span class="flex items-center gap-1 text-danger">
              <img
                *ngIf="errMessBName !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessBName }}</span
            >
            <div class="d-flex gap-2 mt-4">
              <label>Business Email<span class="text-danger">*</span></label>
              <span nz-icon nzType="question-circle" nzTheme="outline"></span> :
            </div>
            <input
              nz-input
              formControlName="business_email"
              placeholder="e.g example@domain.com"
              type="email"
              (keypress)="setRegex($event)"
              (keydown.enter)="$event.preventDefault()"
              (input)="validateEmail()"
              [nzStatus]="validEmail ? '' : 'error'"
            />
            <span class="flex items-center gap-1 text-danger">
              <img
                *ngIf="errMessEmail !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessEmail }}</span
            >
          </div>
          <div class="flex flex-col gap-2 col">
            <div class="flex gap-2">
              <label>Business Type<span class="text-danger">*</span></label>
              <span nz-icon nzType="question-circle" nzTheme="outline"></span> :
            </div>
            <ng-select
              formControlName="business_type"
              [items]="businessTypeList"
              bindLabel="name"
              bindValue="id"
            >
            </ng-select>
            <div class="flex gap-2 mt-4">
              <label>Business Address<span class="text-danger">*</span></label>
              <span nz-icon nzType="question-circle" nzTheme="outline"></span> :
            </div>
            <nz-textarea-count [nzMaxCharacterCount]="100">
              <textarea
                nz-input
                formControlName="business_address"
                rows="2"
                maxlength="100"
                placeholder="e.g Jl.Jend. Soedirman, Jakarta Pusat, 55555"
                (keydown.enter)="$event.preventDefault()"
                (input)="validateAddress()"
                [nzStatus]="validAddress ? '' : 'error'"
              ></textarea>
            </nz-textarea-count>
            <span class="flex items-center gap-1 text-danger">
              <img
                *ngIf="errMessAddress !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessAddress }}</span
            >
          </div>
          <div class="flex flex-col gap-2 col">
            <div class="flex gap-2">
              <label>Business Phone<span class="text-danger">*</span></label>
              <span nz-icon nzType="question-circle" nzTheme="outline"></span> :
            </div>
            <input
              nz-input
              formControlName="business_phone"
              placeholder="e.g 8123456789"
              type="text"
              maxlength="12"
              (keypress)="preventNonNumeric($event)"
              (input)="validateInput($event)"
              [nzStatus]="validNumber ? '' : 'error'"
            />
            <span class="flex items-center gap-1 text-danger">
              <img
                *ngIf="errMessNumber !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessNumber }}</span
            >
          </div>
        </div>

        <div class="flex flex-col gap-2 mt-3">
          <span
            >Is your company willing to allow us to retrieve the information
            from the account settings?</span
          >
          <nz-radio-group
            formControlName="is_account_data_consent"
            class="flex gap-3"
            (keydown.enter)="$event.preventDefault(); !isFormInvalid && onSubmit()"
          >
            <label nz-radio [nzValue]="true">Yes</label>
            <label nz-radio [nzValue]="false">No</label>
          </nz-radio-group>
        </div>

        <div class="flex justify-end gap-2 mt-5">
          <button type="button" class="btn btn-outline-primary" (click)="back()">Back</button>
          <button
            type="submit"
            class="btn text-white"
            [disabled]="isFormInvalid"
            [ngClass]="{
              'btn-secondary': isFormInvalid,
              'btn-primary': !isFormInvalid
            }"
            (click)="onSubmit()"
          >
            Send Request
          </button>
        </div>
      </div>
    </form>
    <app-modal-confirm-back
      [isShowConfirm]="isConfirmBack"
      [docType]="'SLA'"
      (isShowConfirmEvent)="closeConfirmBack()"
    ></app-modal-confirm-back>
  </nz-skeleton>
</div>
